/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Publishprivately1Inputs */

const en_publishprivately1 = /** @type {(inputs: Publishprivately1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish privately`)
};

const de_publishprivately1 = /** @type {(inputs: Publishprivately1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privat veröffentlichen`)
};

/**
* | output |
* | --- |
* | "Publish privately" |
*
* @param {Publishprivately1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const publishprivately1 = /** @type {((inputs?: Publishprivately1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Publishprivately1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_publishprivately1(inputs)
	return de_publishprivately1(inputs)
});
export { publishprivately1 as "publishPrivately" }